import React from 'react';
import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { ActivityField, DescriptionField, EffortField, EffortTypeField, ProjectField, TicketField } from './fields';

/** Modifica di un worklog esistente, con gli stessi campi del form di inserimento. */
export default function WorklogEditDialog({ open, value, errors, onChange, onClose, onSave, saving, projects, activities, effortTypes, project, activity, prefix, dayLabel }) {
  if (!value) return null;
  return (
    <Dialog open={open} onClose={() => !saving && onClose()} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: 800 }}>Edit worklog · {dayLabel}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'grid', gap: 1.25, pt: 1, gridTemplateColumns: { xs: '1fr', md: 'minmax(0,1.6fr) minmax(0,1.4fr) minmax(0,1fr)' } }}>
          <ProjectField projects={projects} value={value.projectId} onChange={(v) => onChange({ projectId: v })} error={errors.project} />
          <ActivityField activities={activities} value={value.activityId} onChange={(v) => onChange({ activityId: v })} error={errors.activity} />
          <EffortTypeField effortTypes={effortTypes} value={value.effortTypeId} onChange={(v) => onChange({ effortTypeId: v })} error={errors.effortTypeId} />
        </Box>
        <Box sx={{ display: 'grid', gap: 1.25, gridTemplateColumns: { xs: '1fr', md: 'minmax(0,1.3fr) minmax(0,0.8fr) minmax(0,2.6fr)' } }}>
          <TicketField
            value={value.ticket}
            onChange={(v) => onChange({ ticket: v })}
            prefix={prefix}
            required={!!activity?.requires_ticket_id}
            hint={activity?.requires_ticket_id ? project?.regex_desc : ''}
            error={errors.ticket}
          />
          <EffortField value={value.effort} onChange={(v) => onChange({ effort: v })} error={errors.effort} />
          <DescriptionField value={value.description} onChange={(v) => onChange({ description: v })} required={!!activity?.requires_description} error={errors.description} />
        </Box>
        {errors.general && <Alert severity="error">{errors.general}</Alert>}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={saving} color="inherit" sx={{ textTransform: 'none' }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={onSave}
          disabled={saving}
          sx={{ textTransform: 'none', fontWeight: 700, boxShadow: 'none', minWidth: 130 }}
        >
          {saving ? <CircularProgress size={18} color="inherit" /> : 'Save changes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
